import React from "react";
//#region types
//#endregion
//#region components
import { PersonSalaryReport } from "components/personSalary";
import { SalaryDraftReport } from "components/salaryDraft";
import useSalaryPermissions from "./hooks/useSalaryPermissions";
import GrossSalaryReport from "./grossSalary/report";
//#endregion

const SalaryReport: React.FC = () => {
  const { getIsGrossSalaryReportAvailable, isSalaryDeviationsAvailable } = useSalaryPermissions();

  return getIsGrossSalaryReportAvailable() ? (
    <GrossSalaryReport />
  ) : isSalaryDeviationsAvailable ? (
    <SalaryDraftReport />
  ) : (
    <PersonSalaryReport />
  );
};

export default SalaryReport;
